import * as e from "react";
import a from "../lib/IconBase.es.js";
import n from "../defs/ChartLine.es.js";
const o = e.forwardRef((r, t) => /* @__PURE__ */ e.createElement(a, { ref: t, ...r, weights: n }));
o.displayName = "ChartLineIcon";
const c = o;
export {
  c as ChartLine,
  o as ChartLineIcon
};
